// src/redux/actions/siteSettingsActions.js
import api from "../utils/axiosInstance";
import { GET_ASSETS_REQUEST, GET_ASSETS_SUCCESS, GET_ASSETS_ERROR, UPDATE_ASSETS_DATA, REMOVE_ASSETS_DATA } from "../ActionTypes/ActionTypes";

export const getAssets = (payload) => async (dispatch) => {
  dispatch({ type: GET_ASSETS_REQUEST });
  try {
    const { data } = await api.post("/user/assets/get-list", payload);
    if (data.success) {
      dispatch({ type: GET_ASSETS_SUCCESS, payload: data.result, });
    } else {
      dispatch({ type: GET_ASSETS_ERROR, payload: data.message });
    }
  } catch (error) {
    dispatch({
      type: GET_ASSETS_ERROR,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getAssetsNoauth = (payload) => async (dispatch) => {
  dispatch({ type: GET_ASSETS_REQUEST });
  try {
    const { data } = await api.post("/user/get-assestlist", payload);
    if (data.success) {
      dispatch({ type: GET_ASSETS_SUCCESS, payload: data.result, });
    } else {
      dispatch({ type: GET_ASSETS_ERROR, payload: data.message });
    }
  } catch (error) {
    dispatch({
      type: GET_ASSETS_ERROR,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const updateAssetData = (newData) => ({
  type: UPDATE_ASSETS_DATA,
  payload: newData,
});


export const removeAssetData = (newData) => ({
  type: REMOVE_ASSETS_DATA,
  payload: newData,
});

